import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';



const LoginComponent = lazy(() => import('../../pages/Account/containers/LoginPageContainer'));
const RegisterComponent = lazy(() => import('../../pages/Account/containers/RegisterPageContainer'));
const ForgotPasswordComponent = lazy(() => import('../../pages/Account/containers/ForgotPwPageContainer'));

const InformationPolicy = lazy( () => import('../Account/containers/InformationPolicy') )

const InformationTerm = lazy( () => import('../Account/containers/InformationTerm') )

const route = [
  {
    path: ROUTERS.LOGIN,
    title: 'Login',
    exact: true,
    public: true,
    component: <LoginComponent />,

  },
  {
    path: ROUTERS.REGISTER,
    title: 'Register',
    exact: true,
    public: true,
    component: <RegisterComponent />,

  },
  {
    path: ROUTERS.FORGOT_PW,
    title: 'Forgot password',
    exact: true,
    public: true,
    component: <ForgotPasswordComponent />,

  },

  {
    path: ROUTERS.INFORMATION_POLICY,
    title: 'Information Policy',
    exact: true,
    public: true,
    component: <InformationPolicy />,
  },

  {
    path: ROUTERS.INFORMATION_TERM,
    title: 'Information Term',
    exact: true,
    public: true,
    component: <InformationTerm />,
  },
];

export default route;